import * as React from "react";
import * as models from "app/models/requireme";
import * as kea from "kea-react";
import { history, match, resources } from "app/main/std";
import { PaquetePPView } from "./view";
import { observeResource } from "kea-resource";
import { createSelectorRx } from "keautils";

interface Props { match: match<{ id: string }> }

export class PaquetePPDetalle extends React.PureComponent<Props> {
    id = (x: Props) => Number.parseInt(this.props.match.params.id);
    valor =createSelectorRx(this.id, id => observeResource(resources.PaquetePP.Get, id));

    render() {
        return <PaquetePPView value={this.valor(this.props)} />
    }
}


// WEBPACK FOOTER //
// ./app/features/general/operativa/items/paquetespp/ver/index.tsx